import { useHistory } from "react-router-dom";

import IconType from "@/components/IconType";
import LegacyResponsiveSideNavigation from "@/components/navigation/LegacyResponsiveSideNavigation";
import { COMING_SOON } from "@/core/constants";

export default function ReportDetailNavigation({ reports, currentSlug, getReportUrl, activeTab }) {
  const history = useHistory();

  const links = reports.map(report => ({
    key: report.slug,
    label: report.name,
    active: report.slug === currentSlug,
    disabled: report.status === COMING_SOON,
    onClick: () => history.push(getReportUrl(report.slug, activeTab)),
    renderIcon: ({ disabled }) => (
      <IconType
        iconType={report?.purchaseProduct?.content?.reportIcon}
        iconSize={24}
        withCircle={false}
        color={disabled ? "carbon" : "dark"}
      />
    )
  }));

  return (
    <LegacyResponsiveSideNavigation
      links={links}
      desktopProps={{ borderRadius: 10 }}
      mobileDropdownProps={{
        maxWidth: [null, null, null, 353],
        width: ["100%", "100%", null],
        borderRadius: 10
      }}
    />
  );
}
